<template>
    <div class="v-app">
        <b-navbar toggleable="md" type="dark" variant="primary" id="header" class="fixed-top">

            <b-navbar-toggle v-if="isLoggedIn" target="nav_collapse"></b-navbar-toggle>

            <b-navbar-brand><b>Ventas</b> Las Pircas</b-navbar-brand>

            <b-collapse is-nav id="nav_collapse" v-if="isLoggedIn">

                <!-- Right aligned nav items -->
                <b-navbar-nav class="ml-auto">

                    <b-nav-item-dropdown text="Contenidos" right v-if="sidebarAccess">
                        <b-dropdown-item to="/casas">Casas</b-dropdown-item>
                        <b-dropdown-item to="/manzanas">Manzanas</b-dropdown-item>
                        <b-dropdown-item to="/lotes">Lotes</b-dropdown-item>
                        <b-dropdown-item to="/usuarios">Usuarios</b-dropdown-item>
                    </b-nav-item-dropdown>

                    <b-nav-item to="/perfil" flat>Perfil de {{user.user_display_name}}</b-nav-item>
                    <b-nav-item to="/logout" flat>Salir</b-nav-item>

                </b-navbar-nav>

            </b-collapse>
        </b-navbar>
        <b-container fluid id="content">
            <router-view></router-view>
        </b-container>
    </div>

</template>

<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'App',
        components: {},
        data() {
            return {
                drawer: true,
            }
        },
        computed: {
            ...mapState('login', ["isLoggedIn"]),
            user() {
                return this.$store.state.login.user;
            },
            sidebarAccess() {
                return this.$store.state.login.isLoggedIn && this.$store.state.login.user.role === 'administrator';
            }
        },
        methods: {
            ...mapActions({
                clearAlert: 'alerts/clearAlert'
            })
        },
        watch: {
            $route(to, from) {
                // clear alert on location change
                this.clearAlert();
            }
        }
    }
</script>

<style>
    #content {
        padding-top: 56px;
    }

    .list-group-item {
        display: flex;
    }

    .list-group-item b {
        flex: 1;
    }

    .list-group-item span {
        flex: 4;
    }

    @media (max-width: 500px) {
        .list-group-item {
            flex-direction: column;
        }
    }
</style>
